import { render, staticRenderFns } from "./MainShopping.vue?vue&type=template&id=15be5024&"
import script from "./MainShopping.vue?vue&type=script&lang=js&"
export * from "./MainShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports